import AppShell from "@/components/feature/app/AppShell";
import type { AppUser } from "@/config/appNav";
import { SuperAdminProvider } from "@/pages/super-admin/data/SuperAdminProvider";
import { SUPER_ADMIN_APP_USER, SUPER_ADMIN_NAV_GROUPS } from "@/config/superAdminNav";
import { useSession } from "@/session/SessionProvider";
import { fullName } from "@/session/types";
import { initialsFromName } from "@/utils/pdfBrand";

const ACCOUNT_LINKS = [
  { label: "Tableau de bord", to: "/super-admin", icon: "ri-dashboard-3-line" },
  { label: "Statistiques", to: "/super-admin/statistiques", icon: "ri-bar-chart-box-line" },
  { label: "Journal d'audit", to: "/super-admin/audit", icon: "ri-shield-check-line" },
];

export default function SuperAdminLayout() {
  const { session } = useSession();
  const userName = session ? fullName(session) : SUPER_ADMIN_APP_USER.name;
  const user: AppUser = session
    ? { name: userName, role: session.fonction, initials: initialsFromName(userName) }
    : SUPER_ADMIN_APP_USER;

  return (
    <SuperAdminProvider>
      <AppShell
        groups={SUPER_ADMIN_NAV_GROUPS}
        user={user}
        spaceLabel="Espace Super Admin"
        fallbackTitle="Tableau de bord"
        accountLinks={ACCOUNT_LINKS}
      />
    </SuperAdminProvider>
  );
}